// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21aqD","colMin":"styles_colMin__3J496"};